import { Box, Button, InputLabel, Stack, Typography } from "@mui/material";
import { AssignScheduleProps } from "../../interface/modal";
import ModalContainer from "../UIElements/modal-container";
import { useTheme } from "@mui/material/styles";
import { TextArea } from "../UIElements/input-ui";
import { labelSty } from "../UIElements/styles-input";
import HistoryTable from "./historyTable";
import { Pagination } from "../Pagination";
import { FC, useState } from "react";
import { TimesheetModalProps } from "../../interface/timesheet";
import CustomDatePicker from "../UIElements/date-picker";
import dayjs from "dayjs";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { LoadingButton } from "@mui/lab";
import { useMutation } from "@tanstack/react-query";
import { apiFlagTimeSheet } from "../../api/timesheet";
import { useNotificationService } from "../notification";
import { useAuth } from "../../hooks/useAuth";
import { getUrlPathId } from "../../utils/url-id";
import { useLocation } from "react-router-dom";

export const FlaggingModal = ({ open, modalHandler, selectedEmployeeId }: any) => {
  const theme = useTheme();
  const { showNotification } = useNotificationService()
  const { token } = useAuth();
  const location = useLocation();
  const timesheetId = getUrlPathId(location?.pathname);

  const [flagReason, setFlagReason] = useState("")
  const mutation = useMutation({
    mutationFn: (fieldValues: {
      flag_note: string;
      employeeId: string;
      token: string;
    }) => apiFlagTimeSheet(fieldValues),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        modalHandler()
        // navigate(PATH_EMPLOYMENT.root);
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  const handleStatus = (e) => {
    e.preventDefault();
    const form = {
      flag_note: flagReason,
      employeeId: selectedEmployeeId,
      token,
    };
    mutation.mutate(form);
  };
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => { }}
    >
      <Box sx={{ background: "#fff", padding: 3, borderRadius: "16px" }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Outfit",
            fontWeight: 500,
            color: "#292925",
          }}
        >
          Flagging User
        </Typography>
        <Box component={"form"} onSubmit={handleStatus}>
          <Stack sx={{ my: 3 }}>
            <InputLabel sx={{ ...labelSty }}>Flagging reason </InputLabel>
            <TextArea
              placeholder={"Enter text here."}
              value={flagReason}
              onchange={(e) => setFlagReason(e.target.value)}
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-around"}
            sx={{ gap: 3 }}
          >
            <Button
              onClick={modalHandler}
              sx={{
                width: 150,
                borderRadius: "12px",
                background: theme.palette.lightBlue.light,
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <LoadingButton type="submit" loading={mutation.isPending}
              sx={{ width: 150, borderRadius: "12px", textTransform: "none" }}
              variant="contained"
            >
              Flag user
            </LoadingButton>
          </Stack>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const TimesheetEmployeeModalTable: FC<TimesheetModalProps> = ({
  open,
  modalHandler,
  paginationState,
  setPaginationState,
  medicData,
}) => {
  const [filterData, setFilterData] = useState("All");
  const [compare, setCompare] = useState(false);

  const handleFilterData = (val: string) => {
    setFilterData(val);
  };
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"lg"}
      openModal={open}
      fullWidth={true}
      handleModal={modalHandler}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: 3,
          borderRadius: "16px",
          minHeight: "65vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              color={"black"}
              variant="body1"
              sx={{
                fontFamily: "Outfit",
                fontWeight: 500,
              }}
            >
              Timesheet History
            </Typography>
            <Button variant="contained" size="small" onClick={modalHandler}>
              close
            </Button>
          </Stack>

          <Button onClick={() => setCompare(!compare)}>
            {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
          </Button>
          {compare && (
            <Stack
              direction={"row"}
              flexWrap={"wrap"}
              alignItems={"flex-end"}
              spacing={3}
              sx={{ mb: 3 }}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                spacing={3}
                sx={{ my: 2 }}
              >
                <Stack sx={{ width: 200 }}>
                  <InputLabel sx={{ ...labelSty }}>Start Date:</InputLabel>
                  <CustomDatePicker
                    label={""}
                    value={dayjs()}
                    onChange={() => {}}
                  />
                </Stack>
                <Stack sx={{ width: 200 }}>
                  <InputLabel sx={{ ...labelSty }}>End Date:</InputLabel>
                  <CustomDatePicker
                    label={""}
                    value={dayjs()}
                    onChange={() => {}}
                  />
                </Stack>
              </Stack>
              <FilterButton
                filterData={filterData}
                handleFilterData={handleFilterData}
              />
              <LoadingButton
                onClick={() => {}}
                loading={false}
                variant="contained"
                sx={{ my: 3, width: 80 }}
              >
                Filter
              </LoadingButton>
            </Stack>
          )}
          <Stack>
            {" "}
            <HistoryTable historyList={medicData} loading={false} />
          </Stack>
        </Box>
        <Pagination
          paginationState={paginationState}
          setPaginationState={setPaginationState}
        />
      </Box>
    </ModalContainer>
  );
};

const btnSty = {
  px: 2,
  py: 1,
  width: 90,
  height: "2.3rem",
  borderRadius: "12px",
  m: 2,
  fontSize: "14px",
  fontWeight: 600,
};
const FilterButton = ({ filterData, handleFilterData }: any) => {
  return (
    <Stack direction="row" flexWrap={"wrap"} sx={{ my: 2 }}>
      <Button
        onClick={() => handleFilterData("All")}
        sx={{
          ...btnSty,
          color: filterData === "All" ? "white" : "#1E1E1E99",
          backgroundColor: filterData === "All" ? "#284CB1" : "#284CB133",
        }}
      >
        All
      </Button>
      <Button
        onClick={() => handleFilterData("Completed")}
        sx={{
          ...btnSty,
          color: filterData === "Completed" ? "white" : "#1E1E1E99",
          backgroundColor: filterData === "Completed" ? "#284CB1" : "#284CB133",
        }}
      >
        Completed
      </Button>
      <Button
        onClick={() => handleFilterData("Swapped")}
        sx={{
          ...btnSty,
          color: filterData === "Swapped" ? "white" : "#1E1E1E99",
          backgroundColor: filterData === "Swapped" ? "#284CB1" : "#284CB133",
        }}
      >
        Swapped
      </Button>
      <Button
        onClick={() => handleFilterData("Absent")}
        sx={{
          ...btnSty,
          color: filterData === "Absent" ? "white" : "#1E1E1E99",
          backgroundColor: filterData === "Absent" ? "#284CB1" : "#284CB133",
        }}
      >
        Absent
      </Button>
    </Stack>
  );
};
